// export const baseUrl1 = "http://192.168.8.17:9999/HKKSNLP"  //冯涛
// export const baseUrl1 = "http://172.18.194.103:8888/HKKnowledgeStudio"  //服务器
// export const baseUrl1 = "http://172.18.130.105:9999/HKKSNLP"  //张云超
// export const baseUrl1 = "/HKKnowledgeStudio"  //打包
export const baseUrl1 = "/HKKSNLP"  //打包




// export const baseUrl2 = "http://192.168.8.17:9999/HKKSNLP/api/rest"//冯涛
// export const baseUrl2 = "http://172.18.194.103:8888/HKKnowledgeStudio/api/rest"//服务器
// export const baseUrl2 = "http://172.18.130.105:9999/HKKSNLP/api/rest"//张云超
// export const baseUrl2 = "/HKKnowledgeStudio/api/rest"//打包
export const baseUrl2 = "/HKKSNLP/api/rest"//打包



export const baseUrl3 = window.getBaseUrl()//张云超
// export const baseUrl3 = ""//张云超